/*
 * Created Date: 16-01-2024, 9:41:04 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

const basePath = '/workspace/question-collection'
export const ROUTER_WORKSPACE_QUESTION_COLLECTION = {
	question_collection: `${basePath}`,
	detail_question_collection: id => (id ? `${basePath}/${id}` : `${basePath}/:id`)
}

export const TRANSLATE_WORKSPACE_QUESTION_COLLECTION = {
	list: `${basePath}/list`,
	detail: `${basePath}/detail`
}
